import BoxListButton from "@components/BoxListButton";
import { FAQ_DETAIL, FAQ_MODIFY } from "@constants/routes";
import { timestampToString } from "@helpers/dates.format";
import IFaq from "@interfaces/faq";

const listFaqMapper = (items: IFaq[], handleDelete: Function) =>
  items.map(({ uuid, question, answer, order, createdAt }) => ({
    uuid,
    question,
    answer,
    order,
    createDate: timestampToString(createdAt),
    _createDateTs: createdAt ?? 0,
    actions: (
      <BoxListButton
        uuid={uuid}
        description={question}
        detailRoute={FAQ_DETAIL}
        modifyRoute={FAQ_MODIFY}
        handleDelete={handleDelete}
      />
    ),
  }));

export default listFaqMapper;
